import React, { useEffect, useState } from 'react'
import { useHistory, useParams, withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { routes } from '../../../../constantes/routes'
import ContactHospitalsListComponent from '../contact-hospitals-detail/ContactHospitalsListComponent'
import { specialtiesActions } from '../../../../actions/specialtiesActions'
import ContactDetailComponent from '../../contacts/contact-detail/ContactDetailComponent'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalSuccessGeneral,
} from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import '../../../../assests/styles/contatcs/ContactDetail.scss'
import Header from '../../../header/Header'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'
import ContactNoteDetail from '../contact-hospitals-detail/ContactNoteDetail'

const EditContactHospitalsContainer = () => {
  const { id } = useParams()
  const history = useHistory()

  const contactsHopitals = useSelector((state) => state.hospitalsContacts)

  const dispatch = useDispatch()
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties(0))
  const deleteContactHospital = (idContactHospital) =>
    dispatch(
      hospitalsContactsActions.deleteOneHospitalContact(idContactHospital),
    )

  const [details, setDetails] = useState({})

  useEffect(() => {
    getInfoContactAndTheirHospitals(id)
    getAllSpecialties()
  }, [id])

  useEffect(() => {
    getInfoContactAndTheirHospitals(id)
  }, [contactsHopitals])

  const getInfoContactAndTheirHospitals = async (idContact) => {
    try {
      const item = contactsHopitals.find(
        (x) => x.id_Contacto.toString() === idContact,
      )
      setDetails(item)
    } catch (error) {
      toContacts()
    }
  }

  const handleRemoveHospitalContact = async (idContactHospital) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el hospital del contacto?',
      )
      if (alert.isConfirmed) {
        await deleteContactHospital(idContactHospital)
        swalSuccessGeneral(swalTitle.Eliminado)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const toContacts = () => {
    history.push(routes.CONTACTS)
  }

  const toEditContactForm = (id) => {
    history.push(routes.CONTACT_EDIT_CONTACT + id)
  }

  const toEditContactHospitalForm = (id) => {
    history.push(routes.CONTACT_EDIT_CONTACT_HOSPITAL + id)
  }

  // Función para añadir un nuevo hospital a este ContactoHospital
  const toAddAnOtherHospitalToContact = () => {
    // El segundo parametro es el state, necesario para el boton cerrar
    history.push(routes.CONTACTS_ADD_HOSPITAL_TO_CONTACT + id, true)
  }

  // Función para editar una nota
  const handleEditNote = (noteId) => {
    // Aquí puedes implementar la lógica para editar la nota
    // Por ejemplo, abrir un modal o navegar a una página de edición
    // Ejemplo: history.push(`/contactos/editar/nota/${noteId}`)
  }

  return (
    <>
      <div className='products'>
        <Header
          text={'Editar detalles del contacto'}
          route={toContacts}
          backBtn={false}
        />
        <ContactDetailComponent
          details={details}
          toEditContactForm={toEditContactForm}
          isEdit={true}
        />
        <ContactHospitalsListComponent
          hospitalsContact={details.hospitalsContacts}
          handleRemoveHospitalContact={handleRemoveHospitalContact}
          toEditContactHospitalForm={toEditContactHospitalForm}
          toAddAnOtherHospitalToContact={toAddAnOtherHospitalToContact}
          editDeleteView={true}
        />
        <ContactNoteDetail canEdit={true} onEditNote={handleEditNote} />
      </div>
    </>
  )
}

export default withRouter(EditContactHospitalsContainer)
